module.exports = __webpack_public_path__ + "static/media/Motorcycle Mechanic.f8206056.jpg";